import {
  roundAll
} from "@/utils/utils";

export default {

  SETFAREWELLOFFICELIST(state, data) {
    data.forEach(item => {
      item.nameAll = item.unitShortName + item.name
    })
    data.unshift({
      nameAll: "全部",
      id: 0
    })
    state.spaceManagement.farewellOfficeList = data
  },

  SETFINDAPPINFOALLLIST(state, data) {
    data.forEach(item => {
      item.value = item.appShortName
    })
    data.push({value:'线上',appShortName:'线上',appId:'-1'})
    state.spaceManagement.findAppInfoAllList = data
  },

  SETFAREWELLOFFICELISTC(state, data) {
    data.forEach(item => {
      item.nameAll = item.unitShortName + item.name
    })
    state.spaceManagement.officeList = data
  },

  SETTITLE(state, data) {
    state.spaceManagement.title = data
  },

  SETTOTALLIST(state, data) {
    state.spaceManagement.totalList = data
  },

  SETPAGEMANAGEMENTLOG(state, data) {
    state.spaceManagement.pageManagementLog = data
  },

  SETPAGEMANAGEMENTLOGUPDATE(state, data) {
    state.spaceDetails.pageManagementLog = data
  },

  SETPAGEMANAGEMENTALL(state, data) {
    state.spaceManagement.pageManagementAll = data
  },

  SETPAGEMANAGEMENTV(state, data) {
    state.spaceManagement.pageManagementV = data
  },

  SETPAGEMANAGEMENTS(state, data) {
    state.spaceManagement.pageManagementS = data
  },

  SETLOGLIST(state, data) {
    state.spaceManagement.logList = []
    data.forEach((item, index) => {
      item.index = index + 1;
      if (item.type == 1) {
        item.contentNew = '新建纪念堂'
      } else if (item.type == 2) {
        item.contentNew = '预约告别厅'
      } else if (item.type == 3) {
        item.contentNew = '冻结纪念堂'
      } else if (item.type == 4) {
        item.contentNew = '解除冻结纪念堂'
      } else if (item.type == 8) {
        item.contentNew = '获取操作权限'
      } else if (item.type == 9) {
        item.contentNew = '保存并结束改动的内容'
      } else if (item.type == 10) {
        item.contentNew = '陵园使用'
      } else if (item.type == 11) {
        item.contentNew = '横版海报编辑'
      } else if (item.type == 12) {
        item.contentNew = '获取上传文件权限'
      } else if (item.type == 13) {
        item.contentNew = '上传'
      } else if (item.type == 14) {
        item.contentNew = '上传失败'
      } else if (item.type == 15) {
        item.contentNew = '敏感内容'
      } else if (item.type == 16) {
        item.contentNew = '备注'
      } else if (item.type == 17) {
        item.contentNew = '访问码下载'
      } else if (item.type == 18) {
        item.contentNew = '小程序认领码下载'
      } else if (item.type == 29) {
        item.contentNew = 'App认领码下载'
      } else if (item.type == 35) {
        item.contentNew = '认领码下载'
      } else if (item.type == 19) {
        item.contentNew = '删除上传'
      } else if (item.type == 20) {
        item.contentNew = '竖版海报编辑'
      } else if (item.type == 23) {
        item.contentNew = '新建'
      }  else if (item.type == 24) {
        item.contentNew = '编辑相册'
      } else if (item.type == 25) {
        item.contentNew = '删除相册'
      } else if (item.type == 26) {
        item.contentNew = '描述内容'
      } else if (item.type == 27) {
        item.contentNew = '迁移'
      } else if (item.type == 28) {
        item.contentNew = '保存改动的内容'
      } else if (item.type == 36 || item.type == 37 || item.type == 38 || item.type == 39 || item.type == 40 || item.type == 41) {
        item.contentNew = item.content;
      }
      if (item.contentDetail != undefined) {
        item.contentDetailJs = JSON.parse(item.contentDetail)
      } else {
        item.contentDetailJs = ''
      }
    })
    state.spaceManagement.logList = data
  },

  SETLOGLISTUPDATE(state, data) {
    data.forEach((item, index) => {
      item.index = index + 1;
      if (item.state == 2) {
        item.content = 'C端删除'
      } else if(item.movePhotoCategorySystem == 1){
        item.content = '移出系统相册'
        item.photoCategoryNameNew = '非系统相册'
      }else{
        item.content = '上传成功'
      }
      if (item.type == 1) {
        item.photoUrl = item.photoUrl + '?x-oss-process=image/resize,m_fill,h_40,w_40'
      } else {
        item.photoUrl = item.photoUrl + '?x-oss-process=video/snapshot,t_1000,f_jpg,w_40,h_40,m_fast'
      }
    })
    state.spaceDetails.logList = data
  },

  SETNUMBER(state, data) {
    state.spaceManagement.number = data
  },

  SETLOGNUMBER(state, data) {
    state.spaceManagement.numberLog = data
  },

  SETLOGNUMBERDETAILS(state, data) {
    state.spaceDetails.numberLog = data
  },

  SETDETAILS(state, data) {
    state.spaceDetails.details = data;
    let k = state.spaceDetails.details.spaceFrozen - 0
    if (k == 1) {
      state.spaceDetails.details.spaceFrozenName = '已冻结'
    } else {
      state.spaceDetails.details.spaceFrozenName = ''
    }

    if (state.spaceDetails.details.foreverState == 1) {
      state.spaceDetails.details.statusName = '永久';
    } else {
      let m = state.spaceDetails.details.status - 0;
      switch (m) {
        case 1:
          state.spaceDetails.details.statusName = '有效';
          break;
        case 2:
          state.spaceDetails.details.statusName = '过期';
          break;
        default:
      }
    }

    if (data.coverUrl != undefined) {
      state.spaceDetails.overUrlOld = data.coverUrl
    } else {
      state.spaceDetails.overUrlOld = ''
    }
    if (data.undertakerTel != undefined && data.undertakerTel != '') {} else {
      state.spaceDetails.details.undertakerTel = '—';
    }
    if (state.spaceDetails.details.amList != undefined && state.spaceDetails.details.amList.length != 0) {
      state.spaceDetails.details.amList.forEach((item) => {
        if (item.fhType == 1) {
          //殡仪馆
          state.spaceDetails.details.nameA = item.unitShortName + item.fhName;
          state.spaceDetails.details.dateA = item.useDate + ' ' + item.startTime.substring(0, 5) + '-' + item.endTime.substring(0, 5);
          if (state.spaceDetails.details.amList.length == 1) {
            state.spaceDetails.details.nameB = '—';
            state.spaceDetails.details.dateB = '—';
          }
        } else if (item.fhType == 2) {
          //陵园
          state.spaceDetails.details.nameB = item.unitShortName + item.fhName;
          state.spaceDetails.details.dateB = item.useDate + ' ' + item.startTime.substring(0, 5) + '-' + item.endTime.substring(0, 5);
          if (state.spaceDetails.details.amList.length == 1) {
            state.spaceDetails.details.nameA = '—';
            state.spaceDetails.details.dateA = '—';
          }
        }
      });
    } else {
      state.spaceDetails.details.nameA = '—';
      state.spaceDetails.details.dateA = '—';
      state.spaceDetails.details.nameB = '—';
      state.spaceDetails.details.dateB = '—';
    }
    state.spaceDetails.spaceHomeForm.name = data.name;
    state.spaceDetails.spaceHomeForm.sex = data.gender;
    
    state.spaceDetails.spaceHomeForm.birthdaySolar = data.birthday;
    state.spaceDetails.spaceHomeForm.birthdayLunar = data.birthdayLunar;
    state.spaceDetails.spaceHomeForm.deaddaySolar = data.deadday;
    state.spaceDetails.spaceHomeForm.deaddayLunar = data.deaddayLunar;
    state.spaceDetails.spaceHomeForm.calendarState = data.calendarState;
    if(data.calendarState == 1){
      state.spaceDetails.spaceHomeForm.birthday = data.birthday;
      state.spaceDetails.spaceHomeForm.deadday = data.deadday;
    }else{
      state.spaceDetails.spaceHomeForm.birthday = data.birthdayLunar;
      state.spaceDetails.spaceHomeForm.deadday = data.deaddayLunar;
    }
    state.spaceDetails.leaveWords = data.viewSinginState == 1 ? true : false
    state.spaceDetails.spacePeopleForm.tel = data.undertakerTel;
    state.spaceDetails.spacePeopleForm.nickeName = data.undertakerNickname;
    state.spaceDetails.spacePeopleForm.name = data.undertakerName;
    if (state.spaceDetails.details.cemetery != undefined) {
      state.spaceDetails.details.cemeteryAll = state.spaceDetails.details.cemeteryUnitShortName + state.spaceDetails.details.cemetery
    } else {
      state.spaceDetails.details.cemeteryAll = '—'
    }
    // if (data.fileSizeUse == 0) {
    //   state.spaceDetails.details.circleUse = 0
    //   state.spaceDetails.details.lineNoUse = 0
    // } else {
    //   state.spaceDetails.details.circleUse = data.fileSizeUse / data.fileSizeCount * 100
    //   state.spaceDetails.details.lineNoUse = data.fileSizeUse / data.fileSizeCount * 100
    //   //state.spaceDetails.details.lineNoUse = (data.fileSizeCount - data.fileSizeUse) / data.fileSizeCount * 100
    //   if (state.spaceDetails.details.circleUse < 1) {
    //     state.spaceDetails.details.circleUse = 1
    //   }
    //   if (state.spaceDetails.details.lineNoUse < 1) {
    //     state.spaceDetails.details.lineNoUse = 1
    //   }
    // }

    if(data.fileVideoSizeUse == 0){
      state.spaceDetails.details.fileVideoSizeUsef = 0
    }else{
      state.spaceDetails.details.fileVideoSizeUsef  = data.fileVideoSizeUse / data.fileSizeCount * 100
      if (state.spaceDetails.details.fileVideoSizeUsef < 1) {
        state.spaceDetails.details.fileVideoSizeUsef = 1
      }
    }
    if(data.filePicSizeUse == 0){
      state.spaceDetails.details.filePicSizeUsef = 0
    }else{
      state.spaceDetails.details.filePicSizeUsef  = data.filePicSizeUse / data.fileSizeCount * 100
      if (state.spaceDetails.details.filePicSizeUsef < 1) {
        state.spaceDetails.details.filePicSizeUsef = 1
      }
    }

    state.spaceDetails.details.createAndCloseTime = state.spaceDetails.details.createTime.substring(0, 11) + ' - ' + state.spaceDetails.details.closeTime;

    state.spaceDetails.details.fileSizeUseA =
      roundAll.roundFn(data.fileSizeUse / 1024 / 1024, 3);
    state.spaceDetails.details.fileSizeCountA =
      roundAll.roundFn((data.fileSizeCount / 1024 / 1024 -
        data.fileSizeUse / 1024 / 1024), 3);

    if(state.spaceDetails.details.lifeTitle1 == undefined){
      state.spaceDetails.details.lifeTitle1 = '个人生平'
    }

    // if(state.spaceDetails.details.lifeTitle2 == undefined){
    //   state.spaceDetails.details.lifeTitle2 = ''
    // }

    // if(state.spaceDetails.details.lifeStory1 == undefined){
    //   state.spaceDetails.details.lifeStory1 = ''
    // }

    // if(state.spaceDetails.details.lifeStory2 == undefined){
    //   state.spaceDetails.details.lifeStory2 = ''
    // }

    if (data.updateState == 1) {
      state.spaceDetails.updateState = false
    } else {
      state.spaceDetails.updateState = true
    }

    if (data.uploadState == 1) {
      state.spaceDetails.uploadState = false
    } else {
      state.spaceDetails.uploadState = true
    }

    if (state.spaceDetails.details.coverUrl != undefined && state.spaceDetails.details.coverUrl != '') {
      state.spaceDetails.isHaveCover = true
    } else {
      state.spaceDetails.isHaveCover = false
    }
  },

  SETDETAILSMIDDLE(state, data) {
    state.spaceDetails.details = data;
    let k = state.spaceDetails.details.spaceFrozen - 0
    if (k == 1) {
      state.spaceDetails.details.spaceFrozenName = '已冻结'
    } else {
      state.spaceDetails.details.spaceFrozenName = ''
    }

    if (state.spaceDetails.details.foreverState == 1) {
      state.spaceDetails.details.statusName = '永久';
    } else {
      let m = state.spaceDetails.details.status - 0;
      switch (m) {
        case 1:
          state.spaceDetails.details.statusName = '有效';
          break;
        case 2:
          state.spaceDetails.details.statusName = '过期';
          break;
        default:
      }
    }

    if (data.coverUrl != undefined) {
      state.spaceDetails.overUrlOld = data.coverUrl
    } else {
      state.spaceDetails.overUrlOld = ''
    }
    if (data.undertakerTel != undefined && data.undertakerTel != '') {} else {
      state.spaceDetails.details.undertakerTel = '—';
    }
    if (state.spaceDetails.details.amList != undefined && state.spaceDetails.details.amList.length != 0) {
      state.spaceDetails.details.amList.forEach((item) => {
        if (item.fhType == 1) {
          //殡仪馆
          state.spaceDetails.details.nameA = item.unitShortName + item.fhName;
          state.spaceDetails.details.dateA = item.useDate + ' ' + item.startTime.substring(0, 5) + '-' + item.endTime.substring(0, 5);
          if (state.spaceDetails.details.amList.length == 1) {
            state.spaceDetails.details.nameB = '—';
            state.spaceDetails.details.dateB = '—';
          }
        } else if (item.fhType == 2) {
          //陵园
          state.spaceDetails.details.nameB = item.unitShortName + item.fhName;
          state.spaceDetails.details.dateB = item.useDate + ' ' + item.startTime.substring(0, 5) + '-' + item.endTime.substring(0, 5);
          if (state.spaceDetails.details.amList.length == 1) {
            state.spaceDetails.details.nameA = '—';
            state.spaceDetails.details.dateA = '—';
          }
        }
      });
    } else {
      state.spaceDetails.details.nameA = '—';
      state.spaceDetails.details.dateA = '—';
      state.spaceDetails.details.nameB = '—';
      state.spaceDetails.details.dateB = '—';
    }
    state.spaceDetails.spaceHomeForm.name = data.name;
    state.spaceDetails.spaceHomeForm.sex = data.gender;

    state.spaceDetails.spaceHomeForm.birthdaySolar = data.birthday;
    state.spaceDetails.spaceHomeForm.birthdayLunar = data.birthdayLunar;
    state.spaceDetails.spaceHomeForm.deaddaySolar = data.deadday;
    state.spaceDetails.spaceHomeForm.deaddayLunar = data.deaddayLunar;
    state.spaceDetails.spaceHomeForm.calendarState = data.calendarState;
    if(data.calendarState == 1){
      state.spaceDetails.spaceHomeForm.birthday = data.birthday;
      state.spaceDetails.spaceHomeForm.deadday = data.deadday;
    }else{
      state.spaceDetails.spaceHomeForm.birthday = data.birthdayLunar;
      state.spaceDetails.spaceHomeForm.deadday = data.deaddayLunar;
    }

    if(state.spaceDetails.details.lifeTitle1 == undefined){
      state.spaceDetails.details.lifeTitle1 = '个人生平'
    }

    state.spaceDetails.leaveWords = data.viewSinginState == 1 ? true : false
    state.spaceDetails.spacePeopleForm.tel = data.undertakerTel;
    state.spaceDetails.spacePeopleForm.nickeName = data.undertakerNickname;
    state.spaceDetails.spacePeopleForm.name = data.undertakerName;
    if (state.spaceDetails.details.cemetery != undefined) {
      state.spaceDetails.details.cemeteryAll = state.spaceDetails.details.cemeteryUnitShortName + state.spaceDetails.details.cemetery
    } else {
      state.spaceDetails.details.cemeteryAll = '—'
    }

    if(data.fileVideoSizeUse == 0){
      state.spaceDetails.details.fileVideoSizeUsef = 0
    }else{
      state.spaceDetails.details.fileVideoSizeUsef  = data.fileVideoSizeUse / data.fileSizeCount * 100
      if (state.spaceDetails.details.fileVideoSizeUsef < 1) {
        state.spaceDetails.details.fileVideoSizeUsef = 1
      }
    }
    if(data.filePicSizeUse == 0){
      state.spaceDetails.details.filePicSizeUsef = 0
    }else{
      state.spaceDetails.details.filePicSizeUsef  = data.filePicSizeUse / data.fileSizeCount * 100
      if (state.spaceDetails.details.filePicSizeUsef < 1) {
        state.spaceDetails.details.filePicSizeUsef = 1
      }
    }

    state.spaceDetails.details.createAndCloseTime = state.spaceDetails.details.createTime.substring(0, 11) + ' - ' + state.spaceDetails.details.closeTime;

    state.spaceDetails.details.fileSizeUseA =
      roundAll.roundFn(data.fileSizeUse / 1024 / 1024, 3);
    state.spaceDetails.details.fileSizeCountA =
      roundAll.roundFn((data.fileSizeCount / 1024 / 1024 -
        data.fileSizeUse / 1024 / 1024), 3);

    if (data.updateState == 1) {
      state.spaceDetails.updateState = false
    } else {
      state.spaceDetails.updateState = true
    }

    if(state.spaceDetails.uploadState){
      state.spaceDetails.details.uploadState = 0    
    }else{
      state.spaceDetails.details.uploadState = 1
    }

    // if (data.uploadState == 1) {
    //   state.spaceDetails.uploadState = false
    // } else {
    //   state.spaceDetails.uploadState = true
    // }

    if (state.spaceDetails.details.coverUrl != undefined && state.spaceDetails.details.coverUrl != '') {
      state.spaceDetails.isHaveCover = true
    } else {
      state.spaceDetails.isHaveCover = false
    }
  },

  SETDETAILSHALF(state, data) {
    state.spaceDetails.details.createTime = data.createTime;
    state.spaceDetails.details.code = data.code;
    state.spaceDetails.details.name = data.name;
    if (data.undertakerTel != undefined && data.undertakerTel != '') {
      state.spaceDetails.details.undertakerTel = data.undertakerTel;
    } else {
      state.spaceDetails.details.undertakerTel = '—';
    }
    state.spaceDetails.details.undertakerNickname = data.undertakerNickname;
    state.spaceDetails.details.undertakerName = data.undertakerName;
    state.spaceDetails.details.foreverState = data.foreverState;
    if (data.amList != undefined && data.amList.length != 0) {
      data.amList.forEach((item) => {
        if (item.fhType == 1) {
          //殡仪馆
          state.spaceDetails.details.nameA = item.unitShortName + item.fhName;
          state.spaceDetails.details.dateA = item.useDate + ' ' + item.startTime.substring(0, 5) + '-' + item.endTime.substring(0, 5);
          if (state.spaceDetails.details.amList.length == 1) {
            state.spaceDetails.details.nameB = '—';
            state.spaceDetails.details.dateB = '—';
          }
        } else if (item.fhType == 2) {
          //陵园
          state.spaceDetails.details.nameB = item.unitShortName + item.fhName;
          state.spaceDetails.details.dateB = item.useDate + ' ' + item.startTime.substring(0, 5) + '-' + item.endTime.substring(0, 5);
          if (state.spaceDetails.details.amList.length == 1) {
            state.spaceDetails.details.nameA = '—';
            state.spaceDetails.details.dateA = '—';
          }
        }
      });
    } else {
      state.spaceDetails.details.nameA = '—';
      state.spaceDetails.dateA = '—';
      state.spaceDetails.details.nameB = '—';
      state.spaceDetails.details.dateB = '—';
    }
    state.spaceDetails.details.createAndCloseTime =
      data.createTime.substring(0, 11) + ' - ' + data.closeTime;
    let k = data.spaceFrozen - 0
    if (k == 1) {
      state.spaceDetails.details.spaceFrozenName = '已冻结'
    } else {
      state.spaceDetails.details.spaceFrozenName = ''
    }

    if (data.foreverState == 1) {
      state.spaceDetails.details.statusName = '永久';
    } else {
      let m = data.status - 0;
      switch (m) {
        case 1:
          state.spaceDetails.details.statusName = '有效';
          break;
        case 2:
          state.spaceDetails.details.statusName = '过期';
          break;
        default:
      }
    }

    if (data.cemetery != undefined) {
      state.spaceDetails.details.cemeteryAll =
        data.cemeteryUnitShortName + data.cemetery
      state.spaceDetails.details.cemetery = data.cemetery
    } else {
      state.spaceDetails.details.cemeteryAll = '—'
      state.spaceDetails.details.cemetery = ''
    }
    state.spaceDetails.details.visitorFrozen = data.visitorFrozen
    state.spaceDetails.details.spaceFrozen = data.spaceFrozen
    state.spaceDetails.details.claimState = data.claimState
  },

  SETLEAVELIST(state, data) {
    state.spaceDetails.leaveWordList = data;
  },

  SETLEAVEPAGE(state, data) {
    state.spaceDetails.pageManagement = data;
  },

  SETPEOPLELIST(state, data) {
    state.spaceDetails.peopleList = data;
  },

  SETUPDATE(state, data) {
    state.spaceDetails.updateState = data;
  },

  SETUPLOAD(state, data) {
    state.spaceDetails.uploadState = data;
  },

  SETWORDS(state, data) {
    state.spaceDetails.leaveWords = data;
  },


  SETQRCODEVISIBLE(state, data) {
    state.spaceDetails.qrcodeVisible = data
  },

  SETQRCODEVISIBLEDOWN(state, data) {
    state.spaceDetails.qrcodeVisibleDown = data
  },

  SETQRCODEVISIBLECLAIMAPP(state, data) {
    state.spaceDetails.qrcodeVisibleClaimApp = data
  },

  SETQRCODEVISIBLECLAIMALL(state, data) {
    state.spaceDetails.qrcodeVisibleClaimAll = data
  },

  SETQRCODEVISIBLECLAIM(state, data) {
    state.spaceDetails.qrcodeVisibleClaim = data
  },
  
  SETQRCODEVISIBLEDOWNCLAIMAPP(state, data) {
    state.spaceDetails.qrcodeVisibleDownClaimApp = data
  },
  
  SETQRCODEVISIBLEDOWNCLAIMALL(state, data) {
    state.spaceDetails.qrcodeVisibleDownClaimAll = data
  },

  SETQRCODEVISIBLEDOWNCLAIM(state, data) {
    state.spaceDetails.qrcodeVisibleDownClaim = data
  },

  TOSHOWPOSTER(state, data) {
    state.spaceDetails.showOrdown = data
  },

  TOSHOWPOSTERCODE(state, data) {
    state.spaceDetails.showOrdownCode = data
  },

  TOSHOWBGURL(state, data) {
    state.spaceDetails.showBgUrl = data
  },

  TOSHOWBGURLCODE(state, data) {
    state.spaceDetails.showBgUrlCode = data
  },

  FONTCOLOR(state, data) {
    state.spaceDetails.fontColor = data
  },

  FONTCOLORCODE(state, data) {
    state.spaceDetails.fontColorCode = data
  },

  FREEZINGVISITORDIALOG(state, data) {
    state.spaceDetails.freezingVisitorDialog = data
  },

  UNFREEZEDIALOG(state, data) {
    state.spaceDetails.unfreezeDialog = data
  },

  VISITORFROZENCONTENTNEW(state, data) {
    state.spaceDetails.visitorFrozenContentNew = data
  },

  VISITORFROZENCONTENT(state, data) {
    state.spaceDetails.visitorFrozenContent = data
  },

  PHOTOALBUMDATA(state, data) {
    state.spaceDetails.photoAlbumData = data
  },

  PHOTOALBUMDIALOG(state, data) {
    state.spaceDetails.photoAlbumDialog = data
  },

  PHOTOALBUMDETAILS(state, data) {
    state.spaceDetails.photoAlbumDetails = data
  },

  PHOTOCATEGORYLIST(state, data) {
    data.forEach((item)=>{
      item.show = false;
    })
    state.spaceDetails.photoCategoryList = data
  },

  UPDATEFILELIST(state, data) {
    state.spaceDetails.updateFileList = data
  },

  PAGEINFO(state, data) {
    state.spaceDetails.pageInfo = data
  },

  ISCANNEXT(state, data) {
    state.spaceDetails.isCanNext = data
  },
  SETCANUPDATE(state, data) {
    state.spaceDetails.isCanUpdate = data
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/SpaceManagement/mutations.js